"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePlanningItemDeliveryAddressChangeResultClientAddress = void 0;
function parsePlanningItemDeliveryAddressChangeResultClientAddress(data) {
    return data;
}
exports.parsePlanningItemDeliveryAddressChangeResultClientAddress = parsePlanningItemDeliveryAddressChangeResultClientAddress;
